import UserStore from "./userStore";
let userStore = new UserStore();

const stores = {
  userStore
};

export default stores;